import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  getInterviews,
  getRequest,
  postDetailSet,
  putCall,
} from "../../../../helpers/fakebackend_helper";
import {
  CHANGE_THE_STATUS,
  GET_ASSESMENT_QUESTIONS,
  GET_ASSESMENT_SHEET_LIST,
  GET_SUGGESTION,
  GET_THE_SHEET_DATA,
  POST_ASSESMENT_QUESTIONS,
  UPDATE_THE_SHEET,
} from "./actionTypes";
import {
  changeTheStatusFailed,
  changeTheStatusSuccess,
  getAssesmentQuestionsFailed,
  getAssesmentQuestionsSuccess,
  getAssesmentSheetsFailed,
  getAssesmentSheetsSuccess,
  getAssessmentSuggestionFailed,
  getAssessmentSuggestionSuccess,
  getTheSheetDataFailed,
  getTheSheetDataSuccess,
  postAssesmentQuestionsFailed,
  postAssesmentQuestionsSuccess,
  updateTheSheetSuccess,
  uptadeTheSheetFailed,
} from "./actions";
//restapi end point
import * as constClass from "../../../../common/constant/constantURL";
// get candidate list
function* getAssesmentQuestionsHandler() {
  try {
    var url = constClass.REST_API_ASSESMENT_QUESTION;

    var responsJSON = yield call(getInterviews, url);
    yield put(getAssesmentQuestionsSuccess(responsJSON));
  } catch (error) {
    yield put(getAssesmentQuestionsFailed(error));
  }
}

function* getAssesmentSheetDataHandler(data) {
  try {
    let id = data.payload;
    var url = constClass.REST_API_GET_THE_SHEET_DATA;

    var responsJSON = yield call(getInterviews, url + id);
    yield put(getTheSheetDataSuccess(responsJSON));
  } catch (error) {
    yield put(getTheSheetDataFailed(error));
  }
}

function* getAssesmentSheetHandler(data) {
  try {
    var url = constClass.REST_API_GET_ASSESMENT_SHEET_LIST;
    let data1 = data.payload;

    let pageSize;
    if (data1.pageSize) {
      pageSize = "&pageSize=" + data1.pageSize;
    } else {
      pageSize = "";
    }
    let keyword;
    if (data1.searchKeyword) {
      keyword = "&keyWord=" + data1.searchKeyword;
    } else {
      keyword = "";
    }
    let sort = "";
    if (data1.sort) {
      if (data1.sort.startsWith("desc")) {
        sort =
          "&sort=" +
          data1.sort.slice(5, data1.sort.indexOf("]")) +
          "&direction=DESC";
      } else {
        sort =
          "&sort=" +
          data1.sort.slice(4, data1.sort.indexOf("]")) +
          "&direction=ASC";
      }
    } else {
      sort = "";
    }

    var responsJSON = yield call(
      getInterviews,
      url + "?pageNumber=" + data1.pageNumber + pageSize + keyword + sort
    );
    yield put(getAssesmentSheetsSuccess(responsJSON));
  } catch (error) {
    yield put(getAssesmentSheetsFailed(error));
  }
}

function* changeTheStatusHandler(data) {
  try {
    var url = constClass.REST_API_CHANGE_THE_STATUS;
    let data1 = data.payload;

    var responsJSON = yield call(
      getInterviews,
      url + data1.id + "&status=" + data1.status
    );
    yield put(changeTheStatusSuccess(responsJSON));
  } catch (error) {
    yield put(changeTheStatusFailed(error));
  }
}

function* postAssesmentQuestionsHandler(data) {
  try {
    var url = constClass.REST_API_ASSESMENT_QUESTION;
    var responsJSON = yield call(postDetailSet, url, data.payload);
    yield put(postAssesmentQuestionsSuccess(responsJSON));
  } catch (error) {
    yield put(postAssesmentQuestionsFailed(error));
  }
}

function* updateTheSheetHandler(data) {
  try {
    var url = constClass.REST_API_ASSESMENT_QUESTION;
    var responsJSON = yield call(putCall, url, data.payload);
    yield put(updateTheSheetSuccess(responsJSON));
  } catch (error) {
    yield put(uptadeTheSheetFailed(error));
  }
}

function* getSuggestionHandler(data) {
  try {
    var url = constClass.REST_API_ASSESMENT_SUGGESTION+data.payload;
    var responsJSON = yield call(getRequest, url, data.payload);
    yield put(getAssessmentSuggestionSuccess(responsJSON));
  } catch (error) {
    yield put(getAssessmentSuggestionFailed(error));
  }  
}

export function* assesmentQuestionsHandle() {
  yield takeEvery(GET_ASSESMENT_QUESTIONS, getAssesmentQuestionsHandler);
  yield takeEvery(POST_ASSESMENT_QUESTIONS, postAssesmentQuestionsHandler);
  yield takeEvery(GET_ASSESMENT_SHEET_LIST, getAssesmentSheetHandler);
  yield takeEvery(CHANGE_THE_STATUS, changeTheStatusHandler);
  yield takeEvery(GET_THE_SHEET_DATA, getAssesmentSheetDataHandler);
  yield takeEvery(UPDATE_THE_SHEET, updateTheSheetHandler);
  yield takeLatest(GET_SUGGESTION, getSuggestionHandler);
}

function* assesmentQuestionsSaga() {
  yield all([fork(assesmentQuestionsHandle)]);
}

export default assesmentQuestionsSaga;
